// extracted by mini-css-extract-plugin
module.exports = {"quiz":"Quiz_quiz__dSIXI","page":"Quiz_page__wcdxu"};